/**语言配置 */
const CHANNEL_CONFIG = {
    BR: "BR",   //葡语
    US: "US",   //英语
    ID: "ID",   //印尼语
    MX: "ES",    //墨西哥语
    PH: "PH",   //菲律宾语
    VN: "VN",   //越南语
    TH: "TH",   //泰国语
    EG: "EG",   //埃及
    CO: "CO",   //哥伦比亚
    IN: "IN",   //英语
}

/**本地存储 */
const LOCAL_STORE = {
    /**设备id */
    DEVICE_ID: "DEVICE_ID",
    /**用户信息 */
    USER_INFO: "USER_INFO",
    /**账户绑定信息 */
    ACCOUNT_INFO: "ACCOUNT_INFO",
    /**VIP等级 */
    VIP_LEVEL: "VIP_LEVEL",
    /**充值返现等级 */
    CASHBACK_LEVEL: "CASHBACK_LEVEL",
    /**是否已经显示过转盘 */
    IS_SHOW_TRUNTABLE: "IS_SHOW_TRUNTABLE",
    /**是否下载了pwa */
    IS_DOWN_PWA: "IS_DOWN_PWA",
    /**分享链接 */
    SHARE_LINK: "SHARE_LINK",
    /**是否已显示首次充值成功提示 1:已显示 */
    CHARGE_FIRST_TIP : "CHARGE_FIRST_TIP",
    /**进行中的订单 */
    ORDER_IN_PROCESS: "ORDER_IN_PROCESS",
    /**是否显示了新用户 */
    IS_SHOW_NEWPLAYER: "IS_SHOW_NEWPLAYER",
    /**adjust数据 */
    ADJUST_DATA: "ADJUST_DATA",
    /**粘贴板数据 */
    CLIPBOARD_DATA: "CLIPBOARD_DATA",
    /**googleId */
    GOOGLE_ID: "GOOGLE_ID",
    /**apk包名 */
    PACKAGE_NAME: "PACKAGE_NAME",
    /**玩家禁用标识 1:禁用 */
    IS_DISBALE: "IS_DISBALE",
    /**是否输入了绑定信息 1:已绑定 */
    IS_INPUT_BIND: "IS_INPUT_BIND",
    /**是否已显示玩家第一次提现成功提示 */
    IS_SHOW_WITH_SUCCESS: "IS_SHOW_WITH_SUCCESS",
    /**是否该显示提现任务 1:是 */
    IS_SHOW_WITH_TASK: "IS_SHOW_WITH_TASK",
}

/**本地存储 */
const SESSION_STORE = {
    /**游戏列表 */
    GAME_LIST: { key: "GAME_LIST", expireTime: 5 * 60 * 60 * 1000 },
    /**vip等级相关配置 */
    VIP_LEVEL_CONFIG: { key: "VIP_LEVEL_CONFIG", expireTime: 5 * 60 * 60 * 1000 },
    /**充值界面相关配置 */
    CHARGE_VIEW_CONFIG: { key: "CHARGE_VIEW_CONFIG", expireTime: 5 * 60 * 60 * 1000 },
    /**可提现金额 */
    CAN_WITHDRAW_AMOUNT: { key: "CAN_WITHDRAW_AMOUNT", expireTime: 5 * 60 * 60 * 1000 },
    /**亏损返现 */
    LOSS_REFUND: { key: "LOSS_REFUND", expireTime: 5 * 60 * 60 * 1000 },
    /**下注返现 */
    BET_REFUND: { key: "BET_REFUND", expireTime: 5 * 60 * 60 * 1000 },
    /**代理相关数据 */
    PROXY_CONFIG: { key: "PROXY_CONFIG", expireTime: 5 * 60 * 60 * 1000 },
    /**分享相关配置数据 */
    INVITE_CONFIG: { key: "INVITE_CONFIG", expireTime: 5 * 60 * 60 * 1000 },
    /**选中的底部选项下标 */
    NAVBAR_INDEX: { key: "NAVBAR_INDEX", expireTime: 1000 * 60 * 60 * 1000 },
    /**账户信息 */
    ACCOUNT_INFO: { key: "ACCOUNT_INFO", expireTime: 1000 * 60 * 60 * 1000 },
    /**银行卡信息 */
    BANK_LIST: { key: "BANK_LIST", expireTime: 3 * 60 * 60 * 1000 },
}

/**提现返回结果码 */
const WITHDRAW_RESULT_CODE = {
    NEED_UPGRADE_VIP: "need_upgrade_vip",   //需要成为vip
    WEB_WITHDRAW_TIMES_NOT_ENOUGH: "web_withdraw_times_not_enough", //可提现次数不足,每日限提2次
    EXCEEDED_WITHDRAWAL_AMOUNT: "exceeded_withdrawal_amount", //超出vip等级对应的提现金额限制
    ILLEGAL_ACCOUNT: "illegal_account", //账号存在违规行为
    EXIST_PROCESS_ORDER: "exist_process_order", //有订单正在进行中
    NEED_ACTIVE_WHITELIST: "need_active_whitelist", //需要激活白名单
    ONLY_SUPPORT_TEN: "only_support_ten",   //首次提款只能发起订单金额xxx
    NEED_FINISH_TASK: "need_finish_task",   //需要完成任务
    
}

/**玩家类型 */
const USER_TYPE = {
    A: 1,
    B: 2,
    C: 3,
}

/**订单类型 */
const ORDER_TYPE = {
    CPF: 1,
    BANK: 2,    //银行卡
    PHONE: 4,   //手机
    EMAIL: 5,   //email
    WALLET: 6,  //钱包
    QRCODE: 7,   //扫码
    CLABE: 8,    //克拉贝
    GCASH: 9,
    MAYA: 10,
    TM: 11, //prompt pay
    MOMO: 12,
    CNPJ: 14,   //CNPJ
}

const CHARGE_EVENT_TYPE = {
    CHARGE_BACK: 5, //充值返现
    WHITE: 6,   //绑定白名单
}

/**通过多域名访问资源 */
const SOURCES_URL = [
    "https://d33ouy903r3132.cloudfront.net",
    "https://d2948gb6x3un8l.cloudfront.net",
    "https://d6ai7jhuqlwg6.cloudfront.net",
    "https://d9iw3h2m6ignr.cloudfront.net",
    "https://d9adjhefwb7tf.cloudfront.net"
]

/**游戏ID */
const GameID = {
    /**PG 虎 */
    FortuneTiger    : 66121,
    /**PG 牛 */
    FortuneOx       : 66122,	
    /**PG 兔 */
    FortuneRabbit   : 66123,
    /** 生肖鼠 */
    FortuneRat      : 66124,
    /**生肖龙 */
    DragonHatch     : 66127,
    /**海盗 */
    WildBandito     : 66128,
    /** 美人鱼 */
    Mermaid         : 66132,
    /** 精灵矮人 */
    Leprechaun      : 66137,
    /**钱来了 */
    MoneyComing     : 66142,	
    /**糖果火箭 */
    SugarRush       : 66143,
    /**软糖 */
    SweetBonanza    : 66144,
    /**二次元雷神 */
    StarLight       : 66145,
    /**麻将 */
    Mahjong         : 66146,
    /**钓鱼 */
    BigBass         : 66147,
    /**男海盗 */
    CaptainsBounty  : 66148,
    /**小丑牌 */
    SuperAce        : 66149,
    /**女海盗 */	
    QueenBounty     : 66150,
    /**雷神1000 */
    Olimpo1000      : 66151,
    /**阿兹特克 */
    Aztec           : 66163,
    /**幸运猫 */	
    Luckyneko       : 66164,
    /**宝石3 */
    Fortunegems3    : 66166,
    /**宝石2 */
    Fortunegems2    : 66167,
    /**女枪手 */
    Showdown        : 66168,
    /**疯狂777 */
    Crazy777        : 66169,
    /**AKB奔牛 */
    AKBBufflo       : 66170,
    /**PG 蛇 */	
    FortuneSnake    : 66172,
    /**黑猫 */
    ExplorerSlots   : 66173,
    /**火影雷神 */
    PowerOfNinja    : 166145,
    /**雷神之门 */
    Gateofkaca      : 266145,
    /**宙斯索尔 */
    ZeusThor        : 366145,	
    /**3PATTI */
    Patti           : 266136,

}

/**游戏名称 */
const GameName: any = {
    /**PG 虎 */
    66121           : 'FortuneTiger',
    /**PG 牛 */
    66122           : 'FortuneOx',
    /**PG 兔 */
    66123           : 'FortuneRabbit',
    /**生肖鼠 */
    66124           : 'FortuneRat',
    /**生肖龙 */
    66127           : 'DragonHatch',
    /**海盗 */
    66128           : 'WildBandito',
    /**美人鱼 */
    66132           : 'Mermaid',
    /**精灵矮人 */
    66137           : 'Leprechaun',
    /**钱来了 */
    66142           : 'MoneyComing',
    /**糖果火箭 */
    66143           : 'SugarRush',
    /**软糖 */
    66144           : 'SweetBonanza',
    /**二次元雷神 */
    66145           : 'StarLight',
    /**麻将 */
    66146           : 'Mahjong',
    /**钓鱼 */
    66147           : 'BigBass',
    /**男海盗 */
    66148           : 'CaptainsBounty',
    /**小丑牌 */
    66149           : 'SuperAce',
    /**女海盗 */
    66150           : 'QueenBounty',
    /**雷神1000 */
    66151           : 'Olimpo1000',
    /**阿兹特克 */
    66163           : 'Aztec',
    /**幸运猫 */
    66164           : 'Luckyneko',
    /**宝石3 */
    66166           : 'Fortunegems3',
    /**宝石2 */
    66167           : 'Fortunegems2',
    /**女枪手 */
    66168           : 'Showdown',
    /**疯狂777 */
    66169           : 'Crazy777',
    /**AKB奔牛 */
    66170           : 'Bufflo',
    /**PG 蛇 */
    66172           : 'FortuneSnake',
    /**黑猫 */
    66173           : 'ExplorerSlots',
    /**火影雷神 */
    166145          : 'PowerOfNinja',
    /**雷神之门 */
    266145          : 'Gateofkaca',
    /**宙斯索尔 */
    366145          : 'ZeusThor',
    /**3PATTI */
    266136          : 'Patti',
}

/**横屏游戏ID */
const LandScapeGameId = [66143, 66145, 166145, 66144, 266145, 66147, 66146, 366145, 66151, 66166, 66167, 66163, 66164, 66168, 66169, 66170, 66173];

/**cordova chcp命令 */
const CHCP_CONFIG = {
    REQ_CLIPBOARD_DATA: "reqClipBoardData", //获取当前剪切板数据
    REQ_ADJUST: "reqAdjust",    //请求adjust事件
    REQ_GET_ADJUSTDATA: "reqGetAdjustData", //获取adjust数据
    REQ_GET_GOOGLEID: "reqGetGoogleId",   //获取googleAdId
    REQ_PACKAGE_NAME: "reqPackageName",   //获取包名
    REQ_CHANGE_SCENE: "reqChangeScene", //更新屏幕方向
}

/**web包 包名管理 */
const WEB_PACKAGE_NAME_HANDLE = {
    H5_CLIENT: "com.win777.win777",
}

/**订单进结果码 */
const ORDER_PROCESS_CODE = {
    ORDER_CREATED:  1000,   //系统受理提款请求
    SYSTEM_PROCESSING:  1100,   //系统处理中
    CHANNEL_PUBLISHING:  1200,   //系统分配打款通道
    COMMON_CHANNEL_GOT:  1300,   //获得普通打款通道
    VIP_CHANNEL_PUBLISHING:  1400,   //存款完成,系统抢占vip通道中
    CHANNEL_GOT:  1500,   //获得vip打款通道
    PAY_WITHDRAW_SERVICE_FEE:  1600,   //缴纳代付手续费
    BANK_PROCESSING:  1700,   //手续费缴纳完成,银行处理中
    PAY_PERSONAL_TAX:  1800,   //缴纳个税
    PERSONAL_TAX_GOT:  1900,   //银行收到个税,汇款处理中
    ACCOUNT_ERROR:  2000,   //汇款失败,账户错误,待修改
    ACCOUNT_MODIFIED:  2100,   //银行收到更改账户请求,汇款处理
    WITHDRAW_SUCCESS:  2200,   //银行处理成功
    WITHDRAW_FAILED:  2300,   //银行处理失败
}

/**充值对应编码类型 */
const BANK_CODE_CONFIG = {
    DOKUVA: "DOKUVA",
    QRIS: "QRIS",
    DANA: "DANA",
    OVO: "OVO",
    LinkAja: "LinkAja",
    SHOPEEPAY: "SHOPEEPAY",
}

export {
    CHANNEL_CONFIG,
    SOURCES_URL,
    LOCAL_STORE,
    ORDER_TYPE,
    SESSION_STORE,
    USER_TYPE,
    WITHDRAW_RESULT_CODE,
    CHARGE_EVENT_TYPE,
    GameID,
    GameName,
    LandScapeGameId,
    CHCP_CONFIG,
    WEB_PACKAGE_NAME_HANDLE,
    ORDER_PROCESS_CODE,
    BANK_CODE_CONFIG
}